import SampleReceptionInfo from './SampleReceptionInfo';

export default SampleReceptionInfo;
